module.exports = __webpack_public_path__ + "static/media/logotest.c7ea6940.jpg";